<template>
    <div>
        <nav-breadcrumb :menu="[{label: '客户银行账户肖像'}]"/>
        <el-row :gutter="10" class="xzmb10">
            <el-col :span="16">
                <el-card class="box-card card02 xzmb10">
                    <div slot="header" class="clearfix">
                        <span>客户信息</span>
                    </div>
                    <div>
                        <el-row :gutter="10">
                            <el-col :span="12">
                                <table class="table-curtomermesg">
                                    <tbody>
                                        <tr>
                                            <td>客户姓名</td>
                                            <td>XXX</td>
                                        </tr>
                                        <tr>
                                            <td>身份证号码</td>
                                            <td>12321321321321321</td>
                                        </tr>
                                        <tr>
                                            <td>银行卡数量</td>
                                            <td>X张</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </el-col>
                            <el-col :span="12">
                                <el-carousel indicator-position="outside" height="170px">
                                    <el-carousel-item >
                                        <div class="bankCard of">
                                            <ul class="of fl bankCardMesg">
                                                <li>发卡银行：中国建设银行</li>
                                                <li>银行卡号：6227004347581726524</li>
                                                <li>卡性质：</li>
                                            </ul>
                                            <div class="bankIcon of fr">
                                                <img src="../../../assets/images/bank/95533.png">
                                            </div>
                                        </div>    
                                    </el-carousel-item>
                                    <el-carousel-item >
                                        <div class="bankCard of">
                                            <ul class="of fl bankCardMesg">
                                                <li>发卡银行：中国银行</li>
                                                <li>银行卡号：6227004347581726524</li>
                                                <li>卡性质：</li>
                                            </ul>
                                            <div class="bankIcon of fr">
                                                <img src="../../../assets/images/bank/95566.png">
                                            </div>
                                        </div>
                                    </el-carousel-item>
                                </el-carousel>                               
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-card class="box-card card02">
                            <div slot="header" class="clearfix">
                                <span>近6个月收入</span>
                            </div>
                            <div id="myChart1" :style="{height: '340px'}"></div>
                        </el-card>                        
                    </el-col>
                    <el-col :span="12">
                        <el-card class="box-card card02">
                            <div slot="header" class="clearfix">
                                <span>近6个月支出</span>
                            </div>
                            <div id="myChart2" :style="{height: '340px'}"></div>
                        </el-card>                         
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="8">
                <el-card class="box-card card02 xzmb10">
                    <div slot="header" class="clearfix">
                        <span>身份特征及消费偏好</span>
                    </div>
                    <ul class="labelList">
                        <li>理财达人</li>
                        <li>22222</li>
                        <li>33333</li>
                        <li>4444</li>
                        <li>55555</li>
                        <li>666666</li>
                        <li>7777</li>
                    </ul>                    
                </el-card>
                <el-card class="box-card card02">
                    <div slot="header" class="clearfix">
                        <span>交易活跃度</span>
                    </div>
                    <div>
                        <div class="labelChose">
                            高频
                        </div>
                        <ul class="labelChoseMesg">
                            <li>活跃度分为：</li>
                            <li>高频：每月交易记录达到200笔以上；</li>
                            <li>中频：每月交易记录达到100笔以上；</li>
                            <li>低频：每月交易记录达到30笔以上。</li>
                        </ul>
                    </div>                     
                </el-card>
            </el-col>
        </el-row>
        <el-card class="box-card card02 xzmb10">
            <div slot="header" class="clearfix">
                <span>近6个月高频交易往来账户</span>
            </div>
            <div>
                <el-table
                style="width: 100%">
                    <el-table-column
                    label="对方账号"
                    width="180">
                    </el-table-column>
                    <el-table-column
                    label="转入笔数"
                    width="180">
                    </el-table-column>
                    <el-table-column
                    label="转入总额">
                    </el-table-column>
                    <el-table-column
                    label="转出笔数"
                    width="180">
                    </el-table-column>
                    <el-table-column
                    label="转出总额"
                    width="180">
                    </el-table-column>
                    <el-table-column
                    label="操作">
                    </el-table-column>
                </el-table>   
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage4"
                    :page-sizes="[100, 200, 300, 400]"
                    :page-size="100"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="400">
                </el-pagination>                             
            </div>
        </el-card>     
        <el-card class="box-card card02">
            <div slot="header" class="clearfix">
                <span>重点关注往来账户</span>
            </div>
            <div>
                <el-table
                style="width: 100%">
                    <el-table-column
                    label="对方账号"
                    width="180">
                    </el-table-column>
                    <el-table-column
                    label="转入笔数"
                    width="180">
                    </el-table-column>
                    <el-table-column
                    label="转入总额">
                    </el-table-column>
                    <el-table-column
                    label="转出笔数"
                    width="180">
                    </el-table-column>
                    <el-table-column
                    label="转出总额"
                    width="180">
                    </el-table-column>
                    <el-table-column
                    label="操作">
                    </el-table-column>
                </el-table>   
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage4"
                    :page-sizes="[100, 200, 300, 400]"
                    :page-size="100"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="400">
                </el-pagination> 
            </div>
        </el-card>    
    </div>
</template>

<script>

  export default {
    name: "CustomerApplyingBankAP",
    data() {
      return {
        currentPage4: 4
      }
    },
    components: {

    },
    computed: {

    },
    mounted() {
        this.chart1()
        this.chart2()
    },
    methods: {
        chart1(){
            let myChart = this.$echarts.init(document.getElementById('myChart1'))
            myChart.setOption({
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    right: 10,
                    data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
                },
                series: [
                    {
                        name: '访问来源',
                        type: 'pie',
                        radius: ['50%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                show: true,
                                textStyle: {
                                    fontSize: '30',
                                    fontWeight: 'bold'
                                }
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: [
                            {value: 335, name: '直接访问'},
                            {value: 310, name: '邮件营销'},
                            {value: 234, name: '联盟广告'},
                            {value: 135, name: '视频广告'},
                            {value: 1548, name: '搜索引擎'}
                        ]
                    }
                ]                
            });    
        },
        chart2(){
            let myChart = this.$echarts.init(document.getElementById('myChart2'))
            myChart.setOption({
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    right: 10,
                    data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
                },
                series: [
                    {
                        name: '访问来源',
                        type: 'pie',
                        radius: ['50%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                show: true,
                                textStyle: {
                                    fontSize: '30',
                                    fontWeight: 'bold'
                                }
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: [
                            {value: 335, name: '直接访问'},
                            {value: 310, name: '邮件营销'},
                            {value: 234, name: '联盟广告'},
                            {value: 135, name: '视频广告'},
                            {value: 1548, name: '搜索引擎'}
                        ]
                    }
                ]                
            });    
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        }        
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/CustomerApplyingBankAP.vue